import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";
import { OrderCollectionModel, OrderModel } from "@insite/client-framework/Types/ApiModels";
import OrdersListState from "@NA/Store/Data/ADIOrdersListState";

const initialState: OrdersListState = {
    isLoading: false,
    updateCustomerSequence: "-1",
    parameter: {
        refrencenumber: "", // this parameter has been added from Spire Prod
        ordersearchtype: "All",
        status: "All", // this parameter has been added from Spire Prod
        fromDate: "",
        toDate: "",
        sort: "OrderDate DESC",
        customerSequence: "-1",
        currentPage: 1,
        pageSize: 12,
        dateType: "30days",
        selectedpage: "1",
        isSearch: true, // isSearch: "" : From US Spire
        dateRange: "30days",
        dateRangeDesc: "Last 30 day",
        statusDesc: "All",
        page: "1",
        isSearchActive: true, // Added property from Spire Prod
        poNumber: '', // Added property from Spire Prod
       // properties: "{'statusDesc':'All'}",
    },
    ordersList: {
        orders: null,
        uri: "",
        properties: {},
        pagination: null,
        showErpOrderNumber: false,
    },
};

const reducer = {
    "Custom/DispatchLoadOrdersList": (draft: Draft<OrdersListState>, action: { result: OrderCollectionModel }) => {
        draft.isLoading = true;
    },
    "Custom/DispatchCompleteLoadParameter": (draft: Draft<OrdersListState>, action: { parameter: any }) => {
        draft.parameter = action.parameter;
    },

    "Custom/DispatchUpdateCustomerSequence": (draft: Draft<OrdersListState>, action: { result: any }) => {
        draft.updateCustomerSequence = action.result;
    },

    "Custom/DispatchUpdateResetPagination": () => {
        return initialState;
    },

    "Custom/DispatchCompleteLoadOrdersList": (
        draft: Draft<OrdersListState>,
        action: { ordersList: OrderCollectionModel; id: string; errorMessage?: string },
    ) => {
        draft.isLoading = false;

        draft.ordersList = action.ordersList;
    },
};

export default createTypedReducerWithImmer(initialState, reducer);
